// @ts-nocheck

/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncAction } from 'Helpers/redux'
import { APP } from 'Configs/App'
import { CampainDetails, CampainVideos } from 'Containers/Details/DetailsProps'
import { apiCall } from './api'

import { Error } from '../../Types'

export const APPLICANT_UPDATE_EMAIL = createAsyncAction(
  'auth/APPLICANT_UPDATE_EMAIL '
)
export const applicantUpdateEmail = (
  authToken: string | string[],
  email: string,
  callback: (error: Error, res: any) => void
) =>
  apiCall({
    method: 'post',
    endpoint: `${APP.TIKTOK_SERVER}/auth/tiktok/applicant-update-email`,
    query: {
      authToken,
      email,
    },
    types: APPLICANT_UPDATE_EMAIL,
    callback,
  })

export const SET_TOKEN = 'SET_TOKEN'
export const setToken = (token: string | string[]) => ({
  payload: token,
  type: SET_TOKEN,
})

export const APPLICANT_CONFIRM_EMAIL = createAsyncAction(
  'auth/APPLICANT_CONFIRM_EMAIL'
)
export const applicantConfirmEmail = (
  confirmationTokenFromEmail: string | string[],
  callback: (error: Error, res: any) => void
) =>
  apiCall({
    method: 'post',
    endpoint: `${APP.TIKTOK_SERVER}/auth/tiktok/applicant-confirm-email`,
    query: {
      confirmationTokenFromEmail,
    },
    types: APPLICANT_CONFIRM_EMAIL,
    callback,
  })

export const USERS_ME = createAsyncAction('USERS_ME')
export const usersMe = () =>
  apiCall({
    method: 'get',
    endpoint: `${APP.TIKTOK_SERVER}/users/me`,
    types: USERS_ME,
  })

export const GET_OFFERED_CAMPAIGNS = createAsyncAction('GET_OFFERED_CAMPAIGNS')
export const getOfferedCampaigns = () =>
  apiCall({
    method: 'get',
    endpoint: `${APP.TIKTOK_SERVER}/influencer/tiktok/new-tracks`,
    types: GET_OFFERED_CAMPAIGNS,
  })

export const GET_EVENTS_STATISTICS = createAsyncAction('GET_EVENTS_STATISTICS')
export const getEventsStatistics = () =>
  apiCall({
    method: 'get',
    endpoint: `${APP.TIKTOK_SERVER}/influencer/tiktok/events/statistics`,
    types: GET_EVENTS_STATISTICS,
  })

export const OPEN_CAMPAIGN_DETAILS = 'OPEN_CAMPAIGN_DETAILS'
export const openCampaignDetails = (id: number) => ({
  type: OPEN_CAMPAIGN_DETAILS,
  payload: id,
})
export const closeCampaignDetails = () => ({
  type: OPEN_CAMPAIGN_DETAILS,
  payload: 0,
})

export const SET_EVENT_DETAILS = 'SET_EVENT_DETAILS'
export const setEventDetails = payload => ({
  type: SET_EVENT_DETAILS,
  payload,
})

export const ACCEPT_TRACK = createAsyncAction('ACCEPT_TRACK')
export const acceptTrack = (campaignId: number, callback) =>
  apiCall({
    method: 'post',
    endpoint: `${APP.TIKTOK_SERVER}/influencer/tiktok/accept-new-track/${campaignId}`,
    types: ACCEPT_TRACK,
    callback,
  })

export const UPLOAD_VIDEO = createAsyncAction('UPLOAD_VIDEO')
export const uploadVideo = (
  videoTiktokUrl: string,
  eventId: number,
  callback
) =>
  apiCall({
    method: 'put',
    endpoint: `${APP.TIKTOK_SERVER}/influencer/tiktok/upload-video/${eventId}`,
    query: {
      videoTiktokUrl,
    },
    types: UPLOAD_VIDEO,
    callback,
  })

export const GET_CAMPAIGN_TIKTOK_DETAILS = createAsyncAction(
  'GET_CAMPAIGN_TIKTOK_DETAILS'
)
export const getCampaignTikTokDetails = (
  tiktokCampaignId: number,
  callback: (error: Error, payload: CampainDetails) => void
) =>
  apiCall({
    method: 'get',
    endpoint: `${APP.TIKTOK_SERVER}/artist/tiktok/campaigns/${tiktokCampaignId}`,
    types: GET_CAMPAIGN_TIKTOK_DETAILS,
    callback,
  })

export const GET_CAMPAIGN_TIKTOK_VIDEOS = createAsyncAction(
  'GET_CAMPAIGN_TIKTOK_VIDEOS'
)
export const getCampaignTikTokVideos = (
  tiktokCampaignId: number,
  callback: (
    error: Error,
    payload: { data: CampainVideos; meta: unknown }
  ) => void
) =>
  apiCall({
    method: 'get',
    endpoint: `${APP.TIKTOK_SERVER}/artist/tiktok/campaigns/${tiktokCampaignId}/events`,
    types: GET_CAMPAIGN_TIKTOK_VIDEOS,
    callback,
  })

export const GET_INFLUENCER = 'GET_INFLUENCER'
export const getInfluencer = (token: string | string[]) => ({
  payload: token,
  type: GET_INFLUENCER,
})

export const SET_INFLUENCER = 'SET_INFLUENCER'
export const setInfluencer = payload => ({
  type: SET_INFLUENCER,
  payload,
})

export const GET_EVENTS_IN_PROGRESS = createAsyncAction(
  'GET_EVENTS_IN_PROGRESS'
)
export const getEventsInProgress = () =>
  apiCall({
    method: 'get',
    endpoint: `${APP.TIKTOK_SERVER}/influencer/tiktok/events/in-progress`,
    types: GET_EVENTS_IN_PROGRESS,
  })

export const GET_EVENTS_AWAITING_REVIEW = createAsyncAction(
  'GET_EVENTS_AWAITING_REVIEW'
)
export const getEventsAwaitingReview = () =>
  apiCall({
    method: 'get',
    endpoint: `${APP.TIKTOK_SERVER}/influencer/tiktok/events/awaiting-review`,
    types: GET_EVENTS_AWAITING_REVIEW,
  })

export const GET_EVENTS_COMPLETED = createAsyncAction('GET_EVENTS_COMPLETED')
export const getEventsCompleted = () =>
  apiCall({
    method: 'get',
    endpoint: `${APP.TIKTOK_SERVER}/influencer/tiktok/events/completed`,
    types: GET_EVENTS_COMPLETED,
  })

export const GET_EVENTS_CANCELED = createAsyncAction('GET_EVENTS_CANCELED')
export const getEventsCanceled = () =>
  apiCall({
    method: 'get',
    endpoint: `${APP.TIKTOK_SERVER}/influencer/tiktok/events/canceled`,
    types: GET_EVENTS_CANCELED,
  })

export const GET_EVENT_BY_ID = createAsyncAction('GET_EVENT_BY_ID')
export const getEventById = (eventId: number) =>
  apiCall({
    method: 'get',
    endpoint: `${APP.TIKTOK_SERVER}/influencer/tiktok/events/details/${eventId}`,
    types: GET_EVENT_BY_ID,
  })

export const SET_ID = 'SET_ID'
export const setID = payload => ({
  type: SET_ID,
  payload,
})

export const CANCEL_EVENT = createAsyncAction('CANCEL_EVENT')
export const cancelEvent = (
  eventId: number,
  callback: (error: Error, res: any) => void
) =>
  apiCall({
    method: 'post',
    endpoint: `${APP.TIKTOK_SERVER}/influencer/tiktok/cancel-event/${eventId}`,
    types: CANCEL_EVENT,
    callback,
  })
